import React from "react";
import {
  ALL_EVENT_INSTANCES,
  FUTURE_EVENT_INSTANCES,
  SINGLE_EVENT_INSTANCE,
} from "../../../../constants";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TertiaryButton from "../../Buttons/TertiaryButton";
import Checkbox from "../../Checkbox/Checkbox";
import Dropdown from "../../Dropdown/Dropdown";
import PopupHeader from "../PopupHeader";
import useDeleteRecurrencePopupData from "./useDeleteRecurrencePopupData";

const DeleteRecurrencePopup = ({ popupData, closePopup }) => {
  const {
    radioSelectOptions,
    showDropDownDateSelect,
    formattedDatesArr,
    selectedEventDate,
    loading,
    noOptionChosen,
    handleSubmit,
    setOptionActive,
    setSelectedEventDate,
    setIsDropdownOpen,
    isDropdownOpen,
  } = useDeleteRecurrencePopupData({ popupData, closePopup });

  return (
    <>
      <PopupHeader headerTitle="Delete Recurrence" closePopup={closePopup} />
      <div className="p-8" style={{ width: popupData?.popupWidth || "444px" }}>
        <div className="mb-8 text-base text-es-medium-grey font-normal">
          <div className="mb-4">
            <Checkbox
              className="items-start h-4 mt-0.5 mr-2"
              size={6}
              checked={radioSelectOptions[ALL_EVENT_INSTANCES] === true}
              onChange={() => setOptionActive(ALL_EVENT_INSTANCES)}
              label="Delete ALL occurrences"
              labelClassName="text-base text-es-medium-grey font-normal"
            />
          </div>
          <div className="mb-4">
            <Checkbox
              className="items-start h-4 mt-0.5 mr-2"
              size={6}
              checked={radioSelectOptions[SINGLE_EVENT_INSTANCE] === true}
              onChange={() => setOptionActive(SINGLE_EVENT_INSTANCE)}
              label="Delete THIS occurrence"
              labelClassName="text-base text-es-medium-grey font-normal"
            />
          </div>

          <div className="mb-4">
            <Checkbox
              className="items-start h-4 mt-0.5 mr-2"
              size={6}
              checked={radioSelectOptions[FUTURE_EVENT_INSTANCES] === true}
              onChange={() => setOptionActive(FUTURE_EVENT_INSTANCES)}
              label="Delete ALL FUTURE occurrences"
              labelClassName="text-base text-es-medium-grey font-normal"
            />
          </div>
          {/* Dropdown hidden */}
          {false &&
            radioSelectOptions[FUTURE_EVENT_INSTANCES] &&
            showDropDownDateSelect && (
              <div className="mb-4 px-9">
                <Dropdown
                  placeholder="Select recurrence to delete"
                  disableSort
                  options={formattedDatesArr}
                  onChange={(value) => setSelectedEventDate(value)}
                  value={selectedEventDate}
                  disableClear
                  onMenuOpen={() => setIsDropdownOpen(true)}
                  onMenuClose={() => setIsDropdownOpen(false)}
                  className={isDropdownOpen && "mb-72"}
                />
              </div>
            )}
        </div>

        {loading && (
          <div className="text-center text-sm text-white p-2 bg-es-green rounded mb-4">
            Processing request ...
          </div>
        )}

        {!loading && (
          <div className="flex justify-start">
            <PrimaryButton
              onClick={handleSubmit}
              border="es-green"
              background="es-green"
              fontColor="white"
              saveButton
              name="primaryButton"
              disabled={loading || noOptionChosen}
            />
            <div className="ml-2">
              <TertiaryButton
                title="cancel"
                onClick={closePopup}
                border="es-green"
                background="white"
                fontColor="es-green"
                name="primaryButton"
                disabled={loading}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DeleteRecurrencePopup;
